// src/pages/admin/Cupones.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);
const TIPOS = { porcentaje:'Porcentaje %', valor_fijo:'Valor fijo $', envio_gratis:'Envio gratis', primer_pedido:'Solo primer pedido' };
const EMPTY = { codigo:'', descripcion:'', tipo:'porcentaje', valor:'', minimo_compra:'', solo_primer_pedido:false, usos_maximos:'', fecha_inicio:'', fecha_fin:'', activo:true };

export default function Cupones() {
  const [cupones, setCupones] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);

  const load = () => api.get('/cupones').then(r => setCupones(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const abrir = (c = null) => {
    setEditId(c?.id || null);
    setForm(c ? { ...c, solo_primer_pedido: !!c.solo_primer_pedido, activo: !!c.activo } : EMPTY);
    setModal(true);
  };

  const guardar = async () => {
    if (!form.codigo || !form.tipo) return toast.error('Codigo y tipo requeridos');
    if (form.tipo !== 'envio_gratis' && !form.valor) return toast.error('Ingresa el valor del descuento');
    try {
      if (editId) {
        await api.put(`/cupones/${editId}`, form);
        toast.success('Cupon actualizado');
      } else {
        await api.post('/cupones', form);
        toast.success('Cupon creado');
      }
      setModal(false);
      load();
    } catch(err) { toast.error(err.response?.data?.error || 'Error al guardar'); }
  };

  const desactivar = async (id) => {
    await api.delete(`/cupones/${id}`);
    toast.success('Cupon desactivado');
    load();
  };

  const reactivar = async (id) => {
    await api.put(`/cupones/${id}`, { activo: true });
    toast.success('Cupon reactivado');
    load();
  };

  const tipoBadge = (tipo) => {
    const colores = { porcentaje:'badge-blue', valor_fijo:'badge-green', envio_gratis:'badge-yellow', primer_pedido:'badge-yellow' };
    const labels = { porcentaje:'% Porcentaje', valor_fijo:'$ Fijo', envio_gratis:'Envio gratis', primer_pedido:'Primer pedido' };
    return <span className={`badge ${colores[tipo]||'badge-gray'}`}>{labels[tipo]||tipo}</span>;
  };

  const hoy = new Date().toISOString().split('T')[0];

  return (
    <div>
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'14px 28px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:10 }}>
        <div>
          <h1 style={{ fontSize:18, fontWeight:900, color:'var(--forest)' }}>Cupones de descuento</h1>
          <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:2 }}>{cupones.filter(c=>c.activo).length} activos</div>
        </div>
        <button className="btn btn-primary" onClick={() => abrir()}>+ Nuevo cupon</button>
      </div>

      <div style={{ padding:'24px 28px' }}>

        {/* Cupones activos */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:16, marginBottom:28 }}>
          {cupones.filter(c => c.activo).map(c => {
            const vencido = c.fecha_fin && c.fecha_fin < hoy;
            return (
              <div key={c.id} className="card" style={{ borderLeft:`4px solid ${vencido ? 'var(--red)' : 'var(--green)'}` }}>
                <div className="card-body">
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 }}>
                    <div>
                      <div style={{ fontFamily:'monospace', fontSize:18, fontWeight:900, color:'var(--forest)', letterSpacing:1, marginBottom:4 }}>{c.codigo}</div>
                      {tipoBadge(c.tipo)}
                      {c.solo_primer_pedido ? <span className="badge badge-yellow" style={{ marginLeft:4 }}>1er pedido</span> : null}
                      {vencido ? <span className="badge badge-red" style={{ marginLeft:4 }}>Vencido</span> : null}
                    </div>
                    <div style={{ fontSize:22, fontWeight:900, color: c.tipo==='envio_gratis' ? 'var(--teal)' : 'var(--green)' }}>
                      {c.tipo === 'porcentaje' ? `${c.valor}%` : c.tipo === 'valor_fijo' ? fmtCOP(c.valor) : '🚚'}
                    </div>
                  </div>
                  <p style={{ fontSize:13, color:'var(--text-muted)', marginBottom:10, lineHeight:1.5 }}>{c.descripcion}</p>
                  <div style={{ fontSize:12, color:'var(--text-muted)', display:'flex', flexDirection:'column', gap:3, marginBottom:12 }}>
                    {c.minimo_compra > 0 && <span>Minimo: {fmtCOP(c.minimo_compra)}</span>}
                    {c.usos_maximos > 0 && <span>Usos: {c.usos_actuales}/{c.usos_maximos}</span>}
                    {c.fecha_fin && <span style={{ color: vencido ? 'var(--red)' : 'inherit' }}>Vence: {c.fecha_fin}</span>}
                  </div>
                  <div style={{ display:'flex', gap:8 }}>
                    <button className="btn btn-outline btn-sm" onClick={() => abrir(c)}>Editar</button>
                    <button className="btn btn-sm" style={{ background:'#fcebeb', color:'var(--red)', border:'none' }} onClick={() => desactivar(c.id)}>Desactivar</button>
                    <button className="btn btn-sm" style={{ background:'#a32d2d', color:'#fff', border:'none' }} onClick={async () => { if(window.confirm('Eliminar cupon?')) { await api.delete('/cupones/'+c.id); load(); }}}>Eliminar</button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Tabla completa */}
        <div className="card">
          <div className="card-header"><span className="card-title">Todos los cupones</span></div>
          <table className="table">
            <thead><tr><th>Codigo</th><th>Tipo</th><th>Valor</th><th>Minimo</th><th>Usos</th><th>Vencimiento</th><th>Estado</th><th></th></tr></thead>
            <tbody>
              {cupones.map(c => {
                const vencido = c.fecha_fin && c.fecha_fin < hoy;
                return (
                  <tr key={c.id}>
                    <td><span style={{ fontFamily:'monospace', fontWeight:800, fontSize:14 }}>{c.codigo}</span></td>
                    <td>{tipoBadge(c.tipo)}{c.solo_primer_pedido ? <span className="badge badge-yellow" style={{ marginLeft:4 }}>1er pedido</span> : null}</td>
                    <td style={{ fontWeight:700 }}>{c.tipo==='porcentaje' ? `${c.valor}%` : c.tipo==='valor_fijo' ? fmtCOP(c.valor) : 'Gratis'}</td>
                    <td style={{ fontSize:12 }}>{c.minimo_compra > 0 ? fmtCOP(c.minimo_compra) : '-'}</td>
                    <td style={{ fontSize:12 }}>{c.usos_actuales}{c.usos_maximos > 0 ? `/${c.usos_maximos}` : ''}</td>
                    <td style={{ fontSize:12, color: vencido ? 'var(--red)' : 'inherit' }}>{c.fecha_fin || 'Sin limite'}</td>
                    <td>
                      {!c.activo ? <span className="badge badge-gray">Inactivo</span>
                        : vencido ? <span className="badge badge-red">Vencido</span>
                        : <span className="badge badge-green">Activo</span>}
                    </td>
                    <td>
                      <div style={{ display:'flex', gap:6 }}>
                        <button className="btn btn-outline btn-sm" onClick={() => abrir(c)}>Editar</button>
                        {!c.activo && <button className="btn btn-sm" style={{ background:'var(--green-light)', color:'var(--green-dark)', border:'none' }} onClick={() => reactivar(c.id)}>Activar</button>}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL */}
      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div style={{ background:'#fff', borderRadius:18, width:'100%', maxWidth:500, maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ padding:'18px 24px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'center', position:'sticky', top:0, background:'#fff' }}>
              <h2 style={{ fontSize:16, fontWeight:800, color:'var(--forest)' }}>{editId ? 'Editar cupon' : 'Nuevo cupon'}</h2>
              <button onClick={() => setModal(false)} style={{ background:'none', border:'none', fontSize:22, cursor:'pointer' }}>x</button>
            </div>
            <div style={{ padding:24 }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Codigo del cupon *</label>
                  <input className="form-input" value={form.codigo} onChange={e=>setForm(f=>({...f, codigo:e.target.value.toUpperCase()}))} placeholder="Ej: WAWITA20" style={{ fontFamily:'monospace', fontWeight:700, fontSize:16, letterSpacing:1 }} disabled={!!editId} />
                  {!editId && <span style={{ fontSize:11, color:'var(--text-muted)' }}>Solo letras y numeros, sin espacios</span>}
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Descripcion</label>
                  <input className="form-input" value={form.descripcion} onChange={e=>setForm(f=>({...f, descripcion:e.target.value}))} placeholder="Ej: 20% de descuento en tu pedido" />
                </div>
                <div className="form-group">
                  <label className="form-label">Tipo de descuento *</label>
                  <select className="form-input" value={form.tipo} onChange={e=>setForm(f=>({...f, tipo:e.target.value, valor: e.target.value==='envio_gratis'?0:f.valor}))}>
                    <option value="porcentaje">Porcentaje (%)</option>
                    <option value="valor_fijo">Valor fijo ($)</option>
                    <option value="envio_gratis">Envio gratis</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">{form.tipo === 'porcentaje' ? 'Porcentaje (%)' : form.tipo === 'valor_fijo' ? 'Valor ($)' : 'Sin valor'}</label>
                  <input className="form-input" type="number" value={form.valor} onChange={e=>setForm(f=>({...f, valor:e.target.value}))} placeholder={form.tipo==='porcentaje'?'20':form.tipo==='valor_fijo'?'5000':'0'} disabled={form.tipo==='envio_gratis'} />
                </div>
                <div className="form-group">
                  <label className="form-label">Compra minima ($)</label>
                  <input className="form-input" type="number" value={form.minimo_compra} onChange={e=>setForm(f=>({...f, minimo_compra:e.target.value}))} placeholder="0" />
                </div>
                <div className="form-group">
                  <label className="form-label">Usos maximos (0 = ilimitado)</label>
                  <input className="form-input" type="number" value={form.usos_maximos} onChange={e=>setForm(f=>({...f, usos_maximos:e.target.value}))} placeholder="0" />
                </div>
                <div className="form-group">
                  <label className="form-label">Fecha inicio</label>
                  <input className="form-input" type="date" value={form.fecha_inicio} onChange={e=>setForm(f=>({...f, fecha_inicio:e.target.value}))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Fecha vencimiento</label>
                  <input className="form-input" type="date" value={form.fecha_fin} onChange={e=>setForm(f=>({...f, fecha_fin:e.target.value}))} />
                </div>
                <div style={{ gridColumn:'1/-1', display:'flex', gap:20 }}>
                  <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:14, fontWeight:600, cursor:'pointer' }}>
                    <input type="checkbox" checked={!!form.solo_primer_pedido} onChange={e=>setForm(f=>({...f, solo_primer_pedido:e.target.checked}))} />
                    Solo primer pedido
                  </label>
                  <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:14, fontWeight:600, cursor:'pointer' }}>
                    <input type="checkbox" checked={!!form.activo} onChange={e=>setForm(f=>({...f, activo:e.target.checked}))} />
                    Cupon activo
                  </label>
                </div>

                {/* Preview del cupon */}
                {form.codigo && (
                  <div style={{ gridColumn:'1/-1', background:'var(--green-light)', borderRadius:12, padding:16, border:'2px dashed var(--green)' }}>
                    <div style={{ fontSize:11, fontWeight:700, color:'var(--text-muted)', marginBottom:6 }}>PREVIEW</div>
                    <div style={{ fontFamily:'monospace', fontSize:20, fontWeight:900, color:'var(--forest)', letterSpacing:2 }}>{form.codigo}</div>
                    <div style={{ fontSize:14, color:'var(--green-dark)', marginTop:4, fontWeight:600 }}>
                      {form.tipo === 'porcentaje' && form.valor ? `${form.valor}% de descuento` : ''}
                      {form.tipo === 'valor_fijo' && form.valor ? `${fmtCOP(form.valor)} de descuento` : ''}
                      {form.tipo === 'envio_gratis' ? 'Envio gratis' : ''}
                      {form.minimo_compra > 0 ? ` (minimo ${fmtCOP(form.minimo_compra)})` : ''}
                      {form.solo_primer_pedido ? ' · Solo primer pedido' : ''}
                      {form.fecha_fin ? ` · Vence ${form.fecha_fin}` : ''}
                    </div>
                  </div>
                )}
              </div>

              <div style={{ display:'flex', gap:10, marginTop:20 }}>
                <button className="btn btn-primary" style={{ flex:1, padding:12 }} onClick={guardar}>{editId ? 'Guardar cambios' : 'Crear cupon'}</button>
                <button className="btn btn-outline" onClick={() => setModal(false)}>Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
